
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/webbkamera",
      function () {
        return require("private-next-pages/[region]/[resort]/webbkamera.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/webbkamera"])
      });
    }
  